let expantion = document.getElementsByClassName('under');
let expantionswitch = ["off","off"];
window.onscroll = function(){
for(let i = 0,len = expantion.length;i < len;i++){
let ex_clientRect = expantion[i].getBoundingClientRect();
let wh = window.innerHeight;
if(wh > ex_clientRect.top + 30 && expantionswitch[i] === "off") {
expantion[i].classList.add('underline-after');
expantionswitch[i] = "on";
}}}




//アコーディオンメニュー
$(document).ready(function() {
  // タイトルをクリックすると
  $('.accordion').click(function(){
    // クリックした次の要素(コンテンツ)を開閉
    $(this).next().slideToggle(300);
    // タイトルにopenクラスを付け外しして矢印の向きを変更
    $(this).toggleClass("open", 300);
  });
});